import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
  flex: 1;
  position: relative;
`;

export const StyledContentPayloadSidebar = styled.div<{
  isExpanded?: boolean;
}>`
  display: flex;
  flex-direction: column;
  border-right: 1px solid #d5d5d5;
  height: 100%;
  padding: 16px;
  gap: 8px;
`;

export const StyledContentPayloadEditorWrapper = styled.div`
  width: 300px;
  height: 100%;
  overflow: hidden;
  border-radius: 4;
`;

export const StyledCodeEditorWrapper = styled.div`
  flex-grow: 1;
  overflow: hidden;
  border-radius: 4px;
`;
